import { render, staticRenderFns } from "./Arbeitgeberanteil.vue?vue&type=template&id=8099b69c&"
import script from "./Arbeitgeberanteil.vue?vue&type=script&lang=js&"
export * from "./Arbeitgeberanteil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports